export const DISPLAY_TEXT_PREFIX = 'display:';
export const CONSTRAINT_TEXT_SUFFIX = ';';
export const DESTINATION_PRODUCTS_PREFIX = 'dst:';
export const DESTINATION_PRODUCTS_SEPARATOR = ',';
export const FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL = 'XX';
